import { GLIMPSES } from "@/data/siteData";

// Bento span map — row 3 has aligned-height square | CENTERED wide | square (8/9 aspect on sides matches 16/9 on center)
const SPANS = [
  "col-span-12 md:col-span-8 row-span-2 aspect-[16/10] md:aspect-auto",
  "col-span-6 md:col-span-4 aspect-square",
  "col-span-6 md:col-span-4 aspect-square",
  "col-span-6 md:col-span-3 aspect-[8/9]",
  "col-span-12 md:col-span-6 aspect-[16/9]",
  "col-span-6 md:col-span-3 aspect-[8/9]",
  "col-span-6 md:col-span-3 aspect-square",
  "col-span-6 md:col-span-3 aspect-square",
  "col-span-6 md:col-span-3 aspect-square",
  "col-span-6 md:col-span-3 aspect-square",
  "col-span-12 md:col-span-6 aspect-square",
  "col-span-12 md:col-span-6 aspect-square",
  "col-span-6 md:col-span-4 aspect-square",
  "col-span-6 md:col-span-4 aspect-square",
  "col-span-12 md:col-span-4 aspect-square",
];

export const Glimpses = () => {
  return (
    <section id="glimpses" data-testid="glimpses-section" className="border-b border-zinc-200 bg-zinc-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="grid grid-cols-12 gap-6 items-end mb-12 md:mb-16">
          <div className="col-span-12 md:col-span-7">
            <div className="overline text-[#FF2A00] mb-4">/ 06 — Snapshots</div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl uppercase tracking-tighter">
              Moments from
              <br />
              past editions.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-5">
            <p className="text-zinc-600">
              Scenes from the stage, corridors and after-hours — where the real
              conversations happen.
            </p>
          </div>
        </div>

        {/* Bento gallery */}
        <div className="grid grid-cols-12 gap-3 md:gap-4 auto-rows-auto">
          {GLIMPSES.map((src, i) => (
            <div
              key={i}
              className={`overflow-hidden border border-zinc-200 bg-zinc-200 ${
                SPANS[i] || "col-span-6 md:col-span-3 aspect-square"
              }`}
            >
              <img
                src={src}
                alt={`Snapshot ${i + 1}`}
                data-testid={`glimpse-${i}`}
                loading="lazy"
                decoding="async"
                fetchPriority="low"
                className="w-full h-full object-cover hover:scale-[1.03] transition-transform duration-700"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Glimpses;
